var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconS-target",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.075,0 11,4.925 11,11c0,6.075 -4.925,11 -11,11c-6.075,0 -11,-4.925 -11,-11c0,-6.075 4.925,-11 11,-11Zm-8.945,10l2.945,0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-2.945,0c0.461,4.172 3.773,7.484 7.945,7.945l0,-2.945c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,2.945c4.172,-0.461 7.484,-3.773 7.945,-7.945l-2.945,0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l2.945,0c-0.461,-4.172 -3.773,-7.484 -7.945,-7.945l0,2.945c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-2.945c-4.172,0.461 -7.484,3.773 -7.945,7.945Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBTarget);
export default __webpack_public_path__ + "static/media/iconB-target.fa493f649e6ec009480294c625138cea.svg";
export { ForwardRef as ReactComponent };